export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-forrst-f9e44d22f34603afb19236fe8faf10cd.svg";